module.exports = __webpack_public_path__ + "img/main.30ad6827.jpg";